import { EVENT_HANDLER_TYPES } from '../constants';
import { EventHandler } from './EventHandler';

export class Connectivity {

  public static online(): boolean {
    return navigator.onLine;
  }

  public static offline(): boolean {
    return !this.online();
  }

  public static init(): void {
    window.addEventListener('online', () => EventHandler.trigger(EVENT_HANDLER_TYPES.CONNECTIVITY_ONLINE));
    window.addEventListener('offline', () => EventHandler.trigger(EVENT_HANDLER_TYPES.CONNECTIVITY_OFFLINE));
  }
}
